import WebRepository from '../web/WebRepository'
import Api from 'clients/web/Api'
import SummaryHistoryPage from 'model/SummaryHistoryPage'

export class SummaryHistoryPagesRepository extends WebRepository<SummaryHistoryPage> {
  constructor() {
    super(new Api('appointments'))
  }

  async searchSummaryHistoryPage(selector: any, bookmark: string): Promise<SummaryHistoryPage> {
    // important
    const condSummaryImportant = selector.summaryImportant
      ? { summaryImportant: selector.summaryImportant }
      : {}

    return super.searchPage({
      selector: {
        patientId: selector.patientId,
        logs: { $elemMatch: { summary: { $ne: '' }, ...condSummaryImportant } },
      },
      sort: {
        startDateTime: -1,
      },
      limit: 10,
      bookmark: bookmark,
    })
  }
}

export default new SummaryHistoryPagesRepository()
